import { auth } from '../firebaseConfig';

const configuredBaseUrl = process.env.REACT_APP_JOURNEYBOT_API_URL;

export class FeedbackApiError extends Error {
  constructor(message, status, details) {
    super(message);
    this.name = 'FeedbackApiError';
    this.status = status;
    this.details = details;
  }
}

export async function submitFeedback(message) {
  if (!configuredBaseUrl) {
    throw new FeedbackApiError('Feedback is not configured right now.', 0);
  }
  const user = auth.currentUser;
  if (!user) {
    throw new FeedbackApiError('Sign in before sending feedback.', 401);
  }

  const token = await user.getIdToken();
  const response = await fetch(`${configuredBaseUrl.replace(/\/$/, '')}/api/feedback`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ message }),
  });
  const body = response.headers.get('content-type')?.includes('application/json')
    ? await response.json()
    : null;
  if (!response.ok) {
    throw new FeedbackApiError(
      body?.message ?? 'We could not send your feedback. Please try again.',
      response.status,
      body,
    );
  }
  return body;
}

